export const reviewsTranslate = {
    es : {
        title: "¡Decídete a ser Viva Fan!",
        content: [
            "“Por los precios asequibles, promociones, puntualidad y buen servicio.”",
            "“Porque te ahorras muy buen dinero al comprar con la membresía, sobre todo si eres de los que vuelan más de dos veces al año.”",
            "“Con hacer dos vuelos redondos con ustedes uno recupera el dinero de la membresía, de ahí en adelante es ahorro en cada vuelo.”",
            "“Sí la recomiendo, he viajado con descuentos muy buenos. ¡Se ahorra buen dinero con Viva Fan!”."
        ],
        button:  "Suscribirme",
        buttonLogin: "Ir al Dashboard"

    },
    eng : {
        title: "Become a Viva Fan!",
        content: [
            "“For the affordable prices, promotions, on-time flights, and good service.”",
            "“Because you save a lot of money when you use your membership, especially if you fly more than twice a year.”",
            "“Just by taking two round trip flights, you recover the price of the membership. From then on, you are just saving money on each flight.”",
            "“Yes, I recommend it. I have traveled with terrific discounts. You save lots of money as a Viva Fan!”"
        ],
        button:  "Subscribe",
        buttonLogin: "Go to Dashboard"       
    }
}